import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createTimeTrackingConfigurationEntityInfo } from 'record-it-time-common/entity/entities/TimeTrackingConfiguration/createTimeTrackingConfigurationEntityInfo';
import { TimeTrackingConfiguration } from './timeTrackingConfigurationTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export const timeTrackingConfigurationEntityInfo =
  createTimeTrackingConfigurationEntityInfo<TimeTrackingConfiguration>({
    additionalFieldInfos:
      EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
  });
